import modals from "../../web-sh/src/components/modals";

import PlanNoticeModal from "./PlanNotice";
import WelcomeModal from "./Welcome";
import WelcomeBusinessModal from "./WelcomeBusiness";
import OnboardingModal from "./Onboarding";
import GetExtensionModal from "./GetExtension";
import EnterpriseInvitationsModal from "./EnterpriseInvitations";
import SaleBlackFridayModal from "./SaleBlackFriday";

const modalsComponents = {
  ...modals,
  PlanNoticeModal,
  WelcomeModal,
  WelcomeBusinessModal,
  OnboardingModal,
  GetExtensionModal,
  EnterpriseInvitationsModal,
  SaleBlackFridayModal
}

export default modalsComponents;